module.exports = __webpack_public_path__ + "img/pr-4.e3c8227e.png";